import { render, staticRenderFns } from "./page-transform.vue?vue&type=template&id=40d0d64e&scoped=true"
import script from "./page-transform.vue?vue&type=script&lang=js"
export * from "./page-transform.vue?vue&type=script&lang=js"
import style0 from "./page-transform.vue?vue&type=style&index=0&id=40d0d64e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d0d64e",
  null
  
)

export default component.exports